import { shareActorDataJson } from "@-/dev.improve.haniverse.lib.actor-data-transfer/file";
import { withDeadline } from "@-/dev.improve.haniverse.lib.deadline";
import {
  customLevelPackExportSchema,
  type CustomLevelPack,
} from "@-/dev.improve.haniverse.lib.level.custom";

export async function exportCustomLevelPack(pack: CustomLevelPack): Promise<void> {
  const json = JSON.stringify(
    customLevelPackExportSchema.parse({ format: "haniverse.level-pack", pack, version: 1 }),
    null,
    2,
  );
  await withDeadline({ deadline: 11 * 60_000, operation: "export level pack" }, () =>
    shareActorDataJson(json, `haniverse-level-pack-${pack.id}.json`),
  );
}
